import React from 'react';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { msTeamsProvisionerApp } from '../../GlobalConst/globalConst';
import { createTeamsDeepLink } from '../../helpers/HelperMethods';
import * as microsoftTeams from "@microsoft/teams-js";

const styles = {
    root: {       
        position: "absolute",
        top: "40px",
        right: "35px",
        height: "50px",
        width: "250px",
        zIndex: "10",
        backgroundColor: "#e6e6e6",
        border: "2px solid transparent",
        borderRadius: "4px",    
        "&:hover" : {
            backgroundColor: "#cccccc" ,
            border: "2px solid #000000",
            borderRadius: "4px",
        },
    },  
    label: {
        textTransform: "capitalize",
        fontFamily: "Abb Inside",
        color: "black",
        fontSize: "15px",
        fontWeight: "400",
    },
};

const PowerPlatformHubButton = () => {
    const isMsTeamsApp = false;//todo: useSelector((state) => state.app.isMsTeamsApp)

    const onClick = (event, link) => {
        if (isMsTeamsApp) {
            event.preventDefault()
            const deepLink = createTeamsDeepLink(msTeamsProvisionerApp.id, msTeamsProvisionerApp.deliveryCenterTabId, link, false);
            microsoftTeams.executeDeepLink(deepLink);
        }
    }

    const link = "https://abb.sharepoint.com/sites/powerplatformhub" 

    return (
        <PrimaryButton 
            className = {styles.root} 
            styles = {{ label: styles.label }}
            onClick={(event) => onClick(event, link)}
            href={link}
            target='_blank'
        >
            Power Platform Hub Site
        </PrimaryButton>
    );
}

export default PowerPlatformHubButton;


// WEBPACK FOOTER //
// ./src/components/ManageCenter/PowerPlatformHubButton.js